import ContactUs from "@/components/contact/ContactUs"

const index = () => <ContactUs />

export default index
